import type { SxProps } from '@mui/material/styles';
import type { CriteriaValue } from '@openx/types/targeting/targetingValuesTypes.ts';
import type { JSX } from 'react';
import { StyledBox } from './components/StyledBox.tsx';
import { useGetDimensionLabels } from './hooks/useGetDimensionLabels.ts';

export const DimensionChip = ({
  targetingDimension,
  isInsideOption = false,
  sx,
  isSubsection = false,
}: {
  targetingDimension: CriteriaValue;
  isInsideOption?: boolean;
  sx?: SxProps;
  isSubsection?: boolean;
}): JSX.Element => {
  const { dimensionLabels } = useGetDimensionLabels();

  return (
    <StyledBox
      component="span"
      data-test={`dimension-${isInsideOption}`}
      isInside={isInsideOption}
      isSubsection={isSubsection}
      sx={sx}
    >
      {dimensionLabels[targetingDimension]}
    </StyledBox>
  );
};
